import { Widget } from './component/widget';
import { FeatureFlagProvider } from './hooks/featureFlagProvider';
import './App.css';

export const App = () => {
  return (
    <FeatureFlagProvider>
      <div className="App">
        <Widget />
      </div>
    </FeatureFlagProvider>
  );
}